<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title1">
    {{title}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
</div>

@if (content !== null) {
  <div class="modal-body">
    <p style="font-weight: bold;color: red;">{{content}}</p>
  </div>
}

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">No</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">Yes</button>
</div>